module.exports = __webpack_public_path__ + "img/ayaka.7055a1f0.webp";